// lib/posthog.ts
import { telemetryAPI } from '../api/client';

const POSTHOG_KEY = 'phc_W1LF1nCBkGOQ06XZN0ZWO5tsygUZFHEcIFQOkZYtIoI';

let posthogInstance: typeof import('posthog-js').default | null = null;
let initialized = false;

export async function initPostHog(): Promise<void> {
  if (initialized || !POSTHOG_KEY) return;

  try {
    const config = await telemetryAPI.getConfig();
    if (config.sharing_tier < 1) return;

    // Dynamic import — Tier 0 users never download the 80KB bundle
    const posthog = (await import('posthog-js')).default;
    posthog.init(POSTHOG_KEY, {
      api_host: 'https://eu.i.posthog.com',
      autocapture: {
        element_allowlist: ['button', 'a', 'input'],
      },
      capture_pageview: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
        unmaskTextSelector: '[data-ph-no-mask]', // rrweb option, not in PostHog types
      } as Record<string, unknown>,
      capture_exceptions: true,
    });
    posthog.identify(config.instance_id);
    posthogInstance = posthog;
    initialized = true;
  } catch {
    console.debug('PostHog init skipped');
  }
}

export function shutdownPostHog(): void {
  if (posthogInstance) {
    posthogInstance.reset();
    posthogInstance.opt_out_capturing();
    posthogInstance = null;
    initialized = false;
  }
}

export async function upgradePostHog(): Promise<void> {
  if (posthogInstance && !initialized) {
    // Was previously shut down — re-enable
    posthogInstance.opt_in_capturing();
    initialized = true;
  } else if (!posthogInstance) {
    // Never initialized — do full init
    await initPostHog();
  }
}

export function captureEvent(event: string, properties?: Record<string, unknown>): void {
  if (posthogInstance && initialized) {
    posthogInstance.capture(event, properties);
  }
}

export function captureException(error: Error, context?: Record<string, unknown>): void {
  if (posthogInstance && initialized) {
    posthogInstance.captureException(error, context);
  }
}
